import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

const CalendarInputDay = ({
  day,
  selected = false,
  onChange = console.log
}) => {
  const classList = [
    "calendar-day",
    selected ? "is-selected" : "",
    day.isSame(moment(), "day") ? "is-same-day" : "",
    day.isSame(moment(), "month") ? "is-same-month" : ""
  ].join(" ");

  const handleClick = () => {
    onChange(day);
  };

  return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <div
      className={classList}
      role="button"
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      <span>{day.format("DD")}</span>
    </div>
  );
};

CalendarInputDay.propTypes = {
  selected: PropTypes.bool,
  day: PropTypes.instanceOf(moment).isRequired,
  onChange: PropTypes.func
};

export default CalendarInputDay;
